import React from "react";
import { useJobSetupStore } from "@presentation/stores/JobSetupStore";
import { useShallow } from "zustand/react/shallow";
import { getPipelineOptions } from "@domain/software";
import { RadioGroup } from "@progress/kendo-react-inputs";
import { FieldWrapper } from "@progress/kendo-react-form";

export const JobPipelineSelectionBlock: React.FC = () => {
  const { software, pipelineType, setPipelineType } = useJobSetupStore(
    useShallow((state) => ({
      software: state.CreateJobState.software,
      pipelineType: state.CreateJobState.pipelineType,
      setPipelineType: state.setPipelineType,
    })),
  );

  // Only the pipelines the selected engine actually runs, under that engine's own
  // wording: SpectroMine calls its directDIA equivalent a Pulsar search, and has no
  // library-generation stage at all.
  const data = getPipelineOptions(software).map((option) => ({
    label: option.label,
    value: option.pipelineType,
  }));

  return (
    <fieldset className="k-form-fieldset">
      <legend className="k-form-legend">
        <strong>Pipeline</strong>
      </legend>
      <FieldWrapper>
        <div style={{ marginTop: "-10px" }}>
          <RadioGroup data={data} value={pipelineType} onChange={(e) => setPipelineType(e.value)} layout="horizontal" />
        </div>
      </FieldWrapper>
    </fieldset>
  );
};
